import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getCommonAnalyticsData, withPaymentAnalyticsField } from "../../../../../../../../../../utils/ym.helpers";
import { EAnalyticsActionConstant, EAnalyticsItemTypeConstant } from "../../../../../../../../../../constants";
export var getAnalyticsConverter = function getAnalyticsConverter(_ref) {
  var getAccountType = _ref.getAccountType,
    getWindow = _ref.getWindow,
    ymPushParams = _ref.ymPushParams;
  return function (props) {
    return _objectSpread(_objectSpread({}, props), {}, {
      pricesProps: _objectSpread(_objectSpread({}, props.pricesProps), {}, {
        props: props.pricesProps.props.map(function (prop) {
          return _objectSpread(_objectSpread({}, prop), {}, {
            onClick: function onClick() {
              ymPushParams(withPaymentAnalyticsField(_objectSpread(_objectSpread({}, getCommonAnalyticsData(getWindow(), getAccountType())), {}, {
                action: EAnalyticsActionConstant.Click,
                item_type: EAnalyticsItemTypeConstant.Element,
                element_name: prop.children
              })));
              prop.onClick();
            }
          });
        })
      }),
      inputProps: _objectSpread(_objectSpread({}, props.inputProps), {}, {
        onBlur: function () {
          var _onBlur = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  ymPushParams(withPaymentAnalyticsField(_objectSpread(_objectSpread({}, getCommonAnalyticsData(getWindow(), getAccountType())), {}, {
                    action: EAnalyticsActionConstant.FillIn,
                    item_type: EAnalyticsItemTypeConstant.Field,
                    field_name: 'введите сумму'
                  })));
                  return _context.abrupt("return", props.inputProps.onBlur());
                case 2:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          function onBlur() {
            return _onBlur.apply(this, arguments);
          }
          return onBlur;
        }(),
        onError: function onError() {
          ymPushParams(withPaymentAnalyticsField(_objectSpread(_objectSpread({}, getCommonAnalyticsData(getWindow(), getAccountType())), {}, {
            action: EAnalyticsActionConstant.View,
            item_type: EAnalyticsItemTypeConstant.Message,
            field_name: 'введите сумму',
            message_text: props.inputProps.error,
            object_type: EAnalyticsItemTypeConstant.Field
          })));
        },
        onClear: function onClear() {
          ymPushParams(withPaymentAnalyticsField(_objectSpread(_objectSpread({}, getCommonAnalyticsData(getWindow(), getAccountType())), {}, {
            action: EAnalyticsActionConstant.Click,
            item_type: EAnalyticsItemTypeConstant.Icon,
            field_text: props.inputProps.value,
            icon_type: 'delete',
            object_type: 'field'
          })));
        }
      })
    });
  };
};